var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"play-logo",attrs:{"aria-label":"tobook.link"}},[(!_vm.compact)?_c('span',{staticClass:"play-logo__name"},[_vm._v("tobook")]):_vm._e(),_c('span',{staticClass:"play-logo__tld"},[_vm._v(".link")])])}
var staticRenderFns = []

export { render, staticRenderFns }